import { useEffect } from "react";

function ProductForm({ productData, setProductData, formErrors }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onChange = (e) => {
    const { name, value } = e.target;
    // Actualiza los campos simples (year es ahora un campo numérico)
    setProductData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ----- Campos dinámicos para Bibliografía (hasta 3 entradas) -----
  const addBibliographyEntry = () => {
    const newBibliography = Array.isArray(productData.bibliography)
      ? [...productData.bibliography]
      : [];
    if (newBibliography.length < 3) {
      newBibliography.push({ title: "", url: "" });
      setProductData((prev) => ({
        ...prev,
        bibliography: newBibliography,
      }));
    }
  };

  const removeBibliographyEntry = (index) => {
    const newBibliography = Array.isArray(productData.bibliography)
      ? [...productData.bibliography]
      : [];
    newBibliography.splice(index, 1);
    setProductData((prev) => ({
      ...prev,
      bibliography: newBibliography,
    }));
  };

  const onBibliographyChange = (index, field, value) => {
    const newBibliography = Array.isArray(productData.bibliography)
      ? [...productData.bibliography]
      : [];
    newBibliography[index] = {
      ...newBibliography[index],
      [field]: value,
    };
    setProductData((prev) => ({
      ...prev,
      bibliography: newBibliography,
    }));
  };
  // ----------------------------------------------------------

  return (
    <div className="border-t pt-6">
      <h2 className="text-2xl font-bold mb-6">Validate Product Data</h2>
      <form autoComplete="off" className="space-y-6">
        {/* Información Básica */}
        <div>
          <h3 className="text-lg font-semibold mb-2">Basic Information</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Product Name
              </label>
              <input
                type="text"
                name="name"
                value={productData.name || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              />
              {formErrors.name && (
                <p className="text-red-500 text-sm">{formErrors.name}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Price
              </label>
              <input
                type="text"
                name="price"
                value={productData.price || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              />
              {formErrors.price && (
                <p className="text-red-500 text-sm">{formErrors.price}</p>
              )}
            </div>
          </div>

          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700">
              Description
            </label>
            <textarea
              name="description"
              value={productData.description || ""}
              onChange={onChange}
              autoComplete="off"
              rows="4"
              className="mt-1 block w-full border rounded p-2"
            ></textarea>
            {formErrors.description && (
              <p className="text-red-500 text-sm">{formErrors.description}</p>
            )}
          </div>
        </div>

        {/* Detalles del Producto */}
        <div>
          <h3 className="text-lg font-semibold mb-2">Product Details</h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Type
              </label>
              <select
                name="type"
                value={productData.type || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              >
                <option value="">Select a type</option>
                <option value="clothing">Clothing</option>
                <option value="furniture">Furniture</option>
                <option value="jewelry">Jewelry</option>
                <option value="art">Art</option>
                <option value="books">Books</option>
                <option value="electronics">Electronics</option>
                <option value="collectibles">Collectibles</option>
              </select>
              {formErrors.type && (
                <p className="text-red-500 text-sm">{formErrors.type}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Condition
              </label>
              <select
                name="condition"
                value={productData.condition || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              >
                <option value="">Select a condition</option>
                <option value="regular">Regular</option>
                <option value="good">Good</option>
                <option value="excellent">Excellent</option>
                <option value="new">New</option>
              </select>
              {formErrors.condition && (
                <p className="text-red-500 text-sm">{formErrors.condition}</p>
              )}
            </div>
          </div>

          {/* Mostrar 'size' solo si se seleccionó 'clothing' */}
          {productData.type?.toLowerCase() === "clothing" && (
            <div className="mt-4">
              <label className="block text-sm font-medium text-gray-700">
                Size
              </label>
              <select
                name="size"
                value={productData.size || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              >
                <option value="">Select a size</option>
                <option value="small">Small</option>
                <option value="medium">Medium</option>
                <option value="large">Large</option>
                <option value="extra_large">Extra Large</option>
              </select>
              {formErrors.size && (
                <p className="text-red-500 text-sm">{formErrors.size}</p>
              )}
            </div>
          )}

          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Color
              </label>
              <input
                type="text"
                name="color"
                value={productData.color || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              />
              {formErrors.color && (
                <p className="text-red-500 text-sm">{formErrors.color}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Material
              </label>
              <input
                type="text"
                name="material"
                value={productData.material || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              />
              {formErrors.material && (
                <p className="text-red-500 text-sm">{formErrors.material}</p>
              )}
            </div>
          </div>

          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Brand
              </label>
              <input
                type="text"
                name="brand"
                value={productData.brand || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              />
              {formErrors.brand && (
                <p className="text-red-500 text-sm">{formErrors.brand}</p>
              )}
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Quantity
              </label>
              <input
                type="text"
                name="quantity"
                value={productData.quantity || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
              />
              {formErrors.quantity && (
                <p className="text-red-500 text-sm">{formErrors.quantity}</p>
              )}
            </div>
          </div>

          <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700">
                Year
              </label>
              <input
                type="number"
                name="year"
                value={productData.year || ""}
                onChange={onChange}
                autoComplete="off"
                className="mt-1 block w-full border rounded p-2"
                min="1900"
                max="2100"
              />
              {formErrors.year && (
                <p className="text-red-500 text-sm">{formErrors.year}</p>
              )}
            </div>
          </div>

          <div className="mt-4">
            <label className="block text-sm font-medium text-gray-700">
              Bibliography
            </label>
            <div>
              {(Array.isArray(productData.bibliography)
                ? productData.bibliography
                : []
              ).map((entry, index) => (
                <div key={index} className="flex gap-2 mb-2 items-center">
                  <input
                    type="text"
                    placeholder="Title"
                    value={entry.title || ""}
                    onChange={(e) =>
                      onBibliographyChange(index, "title", e.target.value)
                    }
                    autoComplete="off"
                    className="block w-1/2 border rounded p-2"
                  />
                  <input
                    type="text"
                    placeholder="URL"
                    value={entry.url || ""}
                    onChange={(e) =>
                      onBibliographyChange(index, "url", e.target.value)
                    }
                    autoComplete="off"
                    className="block w-1/2 border rounded p-2"
                  />
                  <button
                    type="button"
                    onClick={() => removeBibliographyEntry(index)}
                    className="btn btn-sm btn-outline"
                  >
                    Remove
                  </button>
                </div>
              ))}
              {(Array.isArray(productData.bibliography)
                ? productData.bibliography.length
                : 0) < 3 && (
                <button
                  type="button"
                  onClick={addBibliographyEntry}
                  className="btn btn-sm mt-4"
                >
                  Add Entry
                </button>
              )}
            </div>
            {formErrors.bibliography && (
              <p className="text-red-500 text-sm">{formErrors.bibliography}</p>
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

export default ProductForm;
